import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LayoutStoreEntity } from '@/types/redux';
import { HeaderCenterType } from '@goalsetter/ant-design-ui';

const initialState: LayoutStoreEntity = {
  headerProps: {
    headerCenterProps: {
      type: HeaderCenterType.IMAGE,
      imageSource: '',
    },
  },
  footerProps: undefined,
  backgroundColor: undefined,
};

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setHeaderProps: (state, action) => {
      state.headerProps = action.payload;
    },
    setFooterProps: (state, action) => {
      state.footerProps = action.payload;
    },
    setBackgroundColor: (state, action: PayloadAction<string | undefined>) => {
      state.backgroundColor = action.payload;
    },
  },
});

export const { setHeaderProps, setFooterProps, setBackgroundColor } =
  layoutSlice.actions;
export default layoutSlice.reducer;
